import { apiConfig } from "@/helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const tenantService = {
    getMyAvailableTenants,
    switchToTenant,
    getTenantsVisitSummary
};

function getMyAvailableTenants() {    
    console.log('getMyAvailableTenants CALLED')
    return axios.get('/api/services/app/UserTenantAccess/GetMyAvailableTenants', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    });
}

function switchToTenant(tenantId) {
    return axios.post('/api/services/app/UserTenantAccess/SwitchToTenant',
        { tenantId: tenantId },
        {
            baseURL: apiConfig.apiUrl,
            headers: authHeader()
        }
    ).then(response => {
        // If successful, update the stored user token
        if (response.data.result && response.data.result.accessToken) {
            const newUserData = {
                accessToken: response.data.result.accessToken,
                encryptedAccessToken: response.data.result.encryptedAccessToken,
                expireInSeconds: response.data.result.expireInSeconds,
                userId: response.data.result.userId
            };
            localStorage.setItem('user', JSON.stringify(newUserData));
        }
        return response;
    });
}

function getTenantsVisitSummary() {
    return axios.get('/api/services/app/UserTenantAccess/GetTenantsVisitSummary', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    });
}
